<div class="home-wrapper">
  <div nz-col nzSpan="24">
    <h2 class="nfl-form-label" nz-typography>Welcome, {{ firstName }}</h2>
    <p nz-typography class="nfl-form-label">
      The NFL DCR Portal is your centralized hub for managing your data connections, queries and activations in
      collaboration with NFL.
    </p>

    <div class="outer-card">
      <div class="grid-section" *ngIf="authService.hasEntitlements(viewDataConnectionModule)">
        <nz-card class="inner-card" [nzHoverable]="true" [routerLink]="['/data-connection']">
          <span class="icons" nz-icon nzType="database"></span>
          <h5 nz-typography class="card-body-title">Data Connection</h5>
          <p class="nfl-form-label" nz-typography>Connect your data securely</p>
        </nz-card>
      </div>

      <div class="grid-section" *ngIf="authService.hasEntitlements(viewQueryInterfaceModule)">
        <nz-card class="inner-card" [nzHoverable]="true" [routerLink]="['/query']">
          <span class="icons" nz-icon nzType="build"></span>
          <h5 nz-typography class="card-body-title">Query Interface</h5>
          <p class="nfl-form-label" nz-typography>Run secure queries on your data</p>
        </nz-card>
      </div>
      <div class="grid-section" *ngIf="authService.hasEntitlements(viewUserManagementModule)">
        <nz-card class="inner-card" [nzHoverable]="true" [routerLink]="['/users']">
          <span class="icons" nz-icon nzType="user"></span>
          <h5 nz-typography class="card-body-title">Users</h5>
          <p class="nfl-form-label" nz-typography>Manage users and permissions</p>
        </nz-card>
      </div>

      <div class="grid-section">
        <nz-card class="inner-card" [nzHoverable]="true" (click)="openDCRHub()">
          <span class="icons" nz-icon nzType="home"></span>
          <h5 nz-typography class="card-body-title">DCR Hub</h5>
          <p class="nfl-form-label" nz-typography>DCR Hub</p>
        </nz-card>
      </div>
    </div>

    <div class="support-section">
      <div class="support-card">
        <div class="support-content">
          <span class="icons" nz-icon nzType="mail"></span>
          <span class="nfl-form-label">For support, please contact </span>
          <a href="mailto:dcr-admin@nfl.com" class="nfl-form-label support-email">{{ supportEmail }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
